<div class="agenda-card p-3 p-md-4">

  <!-- Move mode: the next free cell becomes the meeting's new time -->
  <div class="move-banner d-flex align-items-center justify-content-between p-3 mb-3" *ngIf="movingAppointment">
    <p class="fs-small fw-500 color-gray-950 mb-0">
      {{'agenda.move_hint'|translate: {name: movingAppointment.student?.name} }}
    </p>
    <a class="fs-small fw-800 color-gray-500 clickable" (click)="cancelMove()">{{'buttons.give_up'|translate}}</a>
  </div>

  <!-- Day picker for small screens -->
  <div class="day-picker d-flex d-lg-none mb-3">
    <a
      *ngFor="let day of days; let i = index"
      class="day-pill fs-xsmall fw-800 clickable text-center"
      [class.active]="selectedDayIndex === i" [class.today]="day.isToday"
      (click)="selectedDayIndex = i">
      <span class="d-block color-gray-400">{{day.date.format('ddd')|uppercase}}</span>
      <span class="d-block">{{day.date.format('D')}}</span>
    </a>
  </div>

  <!-- One pinned strip holds every day header, so the whole row shares a single background -->
  <div class="grid-header d-flex mb-1">
    <div class="time-col"></div>

    <div
      class="day-head text-center" *ngFor="let day of days; let i = index"
      [class.d-none]="selectedDayIndex !== i" [class.d-lg-block]="true" [class.today]="day.isToday">
      <span class="d-block fs-xsmall fw-500 color-gray-400">{{day.date.format('ddd')|uppercase}}</span>
      <span class="fs-small fw-800 color-gray-950">{{day.date.format('D MMM')}}</span>
      <span class="today-badge fs-xsmall fw-800 ms-1" *ngIf="day.isToday">{{'agenda.today_badge'|translate}}</span>
    </div>
  </div>

  <div class="week-grid" [style.--row-count]="rows.length">

    <!-- Time column -->
    <div class="time-col">
      <div class="time-cell fs-xsmall fw-500 color-gray-400" *ngFor="let row of rows">{{row.label}}</div>
    </div>

    <!-- Day columns -->
    <div
      class="day-col" *ngFor="let day of days; let i = index"
      [class.d-none]="selectedDayIndex !== i" [class.d-lg-block]="true">

      <ng-container *ngFor="let row of rows; let rowIndex = index">

        <!-- A card covers its own row and the ones it spans -->
        <div class="grid-cell" *ngIf="!isCoveredByCard(day, rowIndex)"
             [style.grid-row]="'span ' + (cardAt(day, rowIndex)?.rowSpan || 1)">

          <ng-container *ngIf="cardAt(day, rowIndex) as card; else emptyCell">
            <div class="appointment-card level-{{levelKey(card.appointment)}} p-2 h-100">
              <div class="d-flex align-items-start justify-content-between">
                <div class="d-flex align-items-center overflow-hidden">
                  <coach-student-avatar
                    class="me-2" size="xs" [name]="card.appointment.student?.name"
                    [levelKey]="levelKey(card.appointment)"></coach-student-avatar>
                  <p class="fs-small fw-800 color-gray-950 mb-0 text-truncate">{{card.appointment.student?.name}}</p>
                </div>

                <div ngbDropdown container="body" class="d-inline-block">
                  <a class="card-menu clickable" ngbDropdownToggle><i class="bi bi-three-dots-vertical"></i></a>
                  <div ngbDropdownMenu>
                    <button ngbDropdownItem class="fs-small" *ngIf="card.appointment.meetLink"
                            (click)="copyMeetLink(card.appointment)">
                      {{'agenda.copy_meet_link'|translate}}
                    </button>
                    <button ngbDropdownItem class="fs-small" (click)="startMove(card.appointment)">
                      {{'agenda.move_appointment'|translate}}
                    </button>
                    <button ngbDropdownItem class="fs-small color-danger" (click)="openCancel(card.appointment)">
                      {{'agenda.cancel_appointment'|translate}}
                    </button>
                  </div>
                </div>
              </div>

              <p class="fs-xsmall fw-400 color-gray-500 mb-0 mt-1 text-truncate">{{card.appointment.title}}</p>
              <span class="intro-badge fs-xsmall fw-800" *ngIf="card.appointment.type === appointmentType.Intro">
                {{'agenda.intro_meeting'|translate}}
              </span>
            </div>
          </ng-container>

          <ng-template #emptyCell>
            <a class="empty-cell d-flex align-items-center justify-content-center h-100"
               [class.bookable]="isBookable(day, row.minutes)"
               (click)="isBookable(day, row.minutes) && onCellSelected(day, row.minutes)">
              <i class="bi bi-plus" *ngIf="isBookable(day, row.minutes)"></i>
            </a>
          </ng-template>

        </div>
      </ng-container>

    </div>
  </div>

  <p class="fs-xsmall fw-400 color-gray-400 mt-3 mb-0">{{'agenda.grid_hint'|translate}}</p>

  <!-- Meetings left outside the current availability -->
  <div class="outside-box p-3 mt-3" *ngIf="outsideAppointments.length">
    <p class="fs-small fw-800 color-gray-950 mb-1">{{'agenda.outside_availability_title'|translate}}</p>
    <p class="fs-xsmall fw-400 color-gray-400 mb-2">{{'agenda.outside_availability_desc'|translate}}</p>

    <div class="d-flex align-items-center justify-content-between py-1" *ngFor="let item of outsideAppointments">
      <p class="fs-xsmall fw-500 color-gray-950 mb-0">
        {{item.startsAt|date:'d MMMM, HH:mm'}} · {{item.student?.name}} · {{item.title}}
      </p>
      <a class="fs-xsmall fw-800 color-danger clickable" (click)="openCancel(item)">
        {{'agenda.cancel_appointment'|translate}}
      </a>
    </div>

    <a class="fs-xsmall fw-800 color-brand-primary clickable" (click)="availabilityRequested.emit()">
      {{'agenda.manage_availability'|translate}}
    </a>
  </div>

</div>
